module.exports = __webpack_public_path__ + "79747966c9b0aea02fbd59ea0b68fa99.MP3";